import { render, staticRenderFns } from "./RankingCourse.vue?vue&type=template&id=63a048e1&scoped=true"
import script from "./RankingCourse.vue?vue&type=script&lang=js"
export * from "./RankingCourse.vue?vue&type=script&lang=js"
import style0 from "./RankingCourse.vue?vue&type=style&index=0&id=63a048e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a048e1",
  null
  
)

export default component.exports